import { useEffect, useState } from 'react';
import { useCreateListing } from './useCreateListing';
import { useGetOwnListings } from './useGetOwnListings';
import { useUpdateListing } from './useUpdateListing';

export const useListingManager = userId => {
  const [draftCreated, setDraftCreated] = useState(false);
  const { listingFetched, imagesFetched, isLoading, refetch } = useGetOwnListings(userId);
  const { updateListing, isLoading: updateLoading } = useUpdateListing();
  const { createDraft, isLoading: createLoading } = useCreateListing();

  useEffect(() => {
    if (!listingFetched && !draftCreated && !isLoading) {
      setDraftCreated(true);
      (async () => {
        try {
          await createDraft();
          await refetch();
        } catch {}
      })();
    }
  }, [listingFetched]);

  return {
    listing: listingFetched,
    isLoading: createLoading || updateLoading || isLoading,
    imagesFetched,
  };
};
